import { useEffect } from 'react';

export const useBlockScreenFromSleepMode = (isEnabled) => {
  useEffect(() => {
    if (isEnabled) {
      let wakeLock = null;

      const wakeLockReleaseListener = () => {
        wakeLock = null;
        enableWakeLock();
      };

      // Request a screen wake lock
      const enableWakeLock = async () => {
        try {
          if ('wakeLock' in navigator && !wakeLock) {
            wakeLock = await navigator.wakeLock.request('screen');

            wakeLock.addEventListener('release', wakeLockReleaseListener);
          }
        } catch (err) {
          console.warn(`Failed to acquire wake lock: ${err.message}`);
        }
      };

      const handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
          await enableWakeLock();
        }
      };

      enableWakeLock();

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        document.removeEventListener(
          'visibilitychange',
          handleVisibilityChange
        );
        if (wakeLock) {
          wakeLock.removeEventListener('release', wakeLockReleaseListener);
          wakeLock.release().then(() => {
            wakeLock = null;
          });
        }
      };
    }
    return undefined;
  }, [isEnabled]);
};
